import { Component, OnInit } from '@angular/core';
import { DashboardValveMeter } from '../../../../../api/models';
import { DashboardService, EucsDashboardService } from '../../../../../api/services';
import * as Highcharts from 'highcharts';
import more from "highcharts/highcharts-more";
import { ToastrService } from 'ngx-toastr';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { EucsAlarmDashboardService } from 'src/service/eucs-alarm-dashboard.service';

@Component({
  selector: 'app-eucs-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class EucsHomeComponent implements OnInit {
  // Endpoint ad-hoc
  public isEndpointControlActive: boolean = false;
  public isEndpointControlSubmitting: boolean = false;
  public selectedEndpoint: DashboardValveMeter;

  // Device Values
  public batteryVoltageMax: number = 4200
  public signalMax: number = -51;
  public signalMin: number = -133;

  public Highcharts: typeof Highcharts = Highcharts;
  public tankOptions: Highcharts.Options = {};
  public tankCallback: Highcharts.ChartCallbackFunction;
  public tankUpdateFlag: boolean = false;
  public tankOneToOneFlag: boolean = true;

  public flowOptions: Highcharts.Options = {};
  public flowCallback: Highcharts.ChartCallbackFunction;
  public flowUpdateFlag: boolean = false;
  flowLoaded: boolean = false;
  expectedUsage: number;

  constructor(
    public dashboardService: EucsDashboardService,
    public alarmDashboardService: EucsAlarmDashboardService,
    public authService: AzureAuthService,
    public toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.alarmDashboardService.dashboard.reservoirUsage.loaded = false;
    this.alarmDashboardService.refreshData(true);
    this.tankOptions = {
        chart: {
          backgroundColor: "transparent",
          type: 'column',
          height: 300,
          spacing: [5,5,5,5]
        },
        title:{
          text: ""
        },
        credits: {
          enabled: false
        },
        legend:{
          enabled: false
        }
      };
    this.tankCallback = (chart) => this.buildData(chart);
    this.flowCallback = (chart) => this.buildData(chart);

    this.flowOptions = {
      chart: {
        backgroundColor: "transparent",
        type: 'line',
        height: 250,
        spacing: [5,5,5,5]
      },
      title:{
        text: ""
      },
      credits: {
        enabled: false
      },
      legend:{
        enabled: false
      }
    };

    this.dashboardService.EucsDashboardGetReservoirUsages().subscribe(reservoirs => {
      console.log('reservoirs',reservoirs);
      
      let cats = [""];
      let series: any[] = [null];
      for (let res of reservoirs) {
        cats.push(res.name);
        series.push([
          res.percentage          
        ]);
      }
      
      
      this.tankOptions = {
          chart: {
            backgroundColor: "transparent",
            type: 'column',
            height: 300,
            spacing: [5,5,5,5],
            events:{
              load: function(){
                let i = 1; // first item is blank to make space
                for (let res of reservoirs) {
                  console.log(res.name + " = " + res.ageMinutes)
                  if (res.ageMinutes > 600){
                    var point = this.series[0].points[i];
                    point.update({color:'rgba(105, 105, 105, 0.1)'});
                  }
                  i++;
                }
              }
            }
          },
          title:{
            text: ""
          },
          xAxis: {
            categories: cats,
            //margin: 150,
            title: {  
                text: null
            },
            labels:{
              enabled: true,
              style:{
                fontSize:'10px',
                color: 'rgba(255, 255, 255, 0.6)'
              }
            }
          },
          plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                    verticalAlign:'top',
                    color: 'white',
                    style:{
                      fontWeight:'normal'
                    },
                    formatter: function () {
                      return Highcharts.numberFormat(this.y,0) + "%";
                    }
                },
                //pointWidth:35
                //borderWidth:10
            }
          },
          credits: {
            enabled: false
          },
          series: [{ name:'Level', type:'column', color: 'rgba(10, 10, 180, 0.6)', data: series}],
          yAxis: {
              min: 0,
              max: 100,
              title: {
                  text: 'Level (%)',
                  align: 'high'
              },
              labels: {
                enabled: true,
                //overflow: 'justify'
                style:{
                  color:'rgba(255, 255, 255, 0.6)'
                }
              },
              plotBands:[
                {
                  from: 0,
                  to: 20,
                  color: 'rgba(170, 70, 70, 0.2)',
                  label: {
                      text: 'Low',                      
                      style: {
                          color: 'rgba(255, 255, 255, 0.6)',
                          paddingLeft: 10
                      }
                  }
                }, {
                  from: 80,
                  to: 100,
                  color: 'rgba(70, 170, 70, 0.2)',
                  label: {
                      text: 'Full',
                      style: {
                          color: 'rgba(255, 255, 255, 0.6)'
                      }
                  }
                }
              ]
          },
          legend:{
            enabled: false
          },
          tooltip: {
            formatter: function () {
              console.log(this.point);
              return this.point.category + " = " + Highcharts.numberFormat(this.y,0) + "% as of " + reservoirs[(<any>this.point).index - 1].age;
            }
          },
          responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        align: 'left',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    yAxis: {
                        labels: {
                            align: 'right',
                            x: -5,
                            y: 10
                        },
                        title: {
                            text: null
                        }
                    },
                    subtitle: {
                        text: null
                    },
                    credits: {
                        enabled: false
                    }
                }
            }]
        }
      };
      this.alarmDashboardService.dashboard.reservoirUsage.loaded = true;
    });

    this.dashboardService.EucsDashboardGetFlowRates().subscribe(flowrates => {
      var actual = [];
      var expected = [];
      this.expectedUsage = flowrates.remainingUsage;
      if (flowrates.actual){
        for (let v of flowrates.actual){
          actual.push([new Date(v.timeStamp).getTime(), v.value]);
        }
      }
      if (flowrates.expected){
        for (let v of flowrates.expected){
          expected.push([new Date(v.timeStamp).getTime(), v.value]);
        }
      }
      this.flowOptions = {
          chart: {
            backgroundColor: "transparent",
            type: 'line',
            height: 150,
            spacing: [2,2,2,2],
          },
          title:{
            text: ""
          },
          time:{
            useUTC: true,
            timezoneOffset: -600
          },
          xAxis: {
            type: 'datetime',
            //margin: 150,
            plotLines: [{
              color: 'grey',
              dashStyle: 'longdash',
              width: 1,
              value: new Date().getTime()
            }] as any[],
            title: {  
                text: null
            },
            labels:{
              style:{
                color:'rgba(255, 255, 255, 0.6)'
              },
            }
          },
          plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                    verticalAlign:'top',
                    color: 'white',
                    style:{
                      fontWeight:'normal'
                    },
                    formatter: function () {
                      return Highcharts.numberFormat(this.y,0) + "%";
                    }
                },
                //pointWidth:35
                //borderWidth:10
            }
          },
          credits: {
            enabled: false
          },
          series: [
            { name:'Expected', type:'line', color: 'rgba(10, 10, 180, 0.6)', data: expected},
            { name:'Actual', type:'line', color: 'rgba(180, 10, 10, 0.6)', data: actual}
          ],
          yAxis: {
              title: {
                  text: 'Flow Rate (kl/h)',
              },
              labels: {
                enabled: true,
                style:{
                  color:'rgba(255, 255, 255, 0.6)'
                },
                //overflow: 'justify'
              }
          },
          legend:{
            enabled: false
          }
      };
      this.flowLoaded = true;
      //this.alarmDashboardService.dashboard.flowrates.loaded = true;
    });
  }

  private buildData(chart) {
    
  }

  /**
   * Checks that string can be cast to a number
   */
  isValidNumber(string: string): boolean {
    return !Number.isNaN(Number(string));
  }

  endpointHasActiveAlarms(endpoint: any) {
    return  endpoint.aboveExpectedFlowRate.value || endpoint.belowExpectedFlowRate.value ||
            endpoint.deviceInEmptyPipeAlarm.value || endpoint.deviceInLeakAlarm.value ||
            endpoint.projectedWeeklyAllocationExceeded.value || endpoint.valveStateAlarm.value ||
            endpoint.weeklyAllocationExceeded.value || endpoint.rainExceeded.value || endpoint.windSpeedExceeded.value;
  }

  // Endpoint Control
  editEndpointControl(endpoint: DashboardValveMeter): void {
    this.isEndpointControlActive = true;
    this.selectedEndpoint = endpoint;
  }
 
  closeEndpointControl(): void {
    this.isEndpointControlActive = false;
    this.selectedEndpoint = null;
  }

  /**
   * Wipe an existing endpoint control, sends a null command
   */
  wipeEndpointControl(endpoint: DashboardValveMeter) {
    this.dashboardService
      .EucsDashboardControlEndpoint({expiration: '00:00:00', endpointId: endpoint.endpointId, command: null})
      .subscribe(
        data => {
          this.alarmDashboardService.getDashboardMeterDetails()
          this.toastr.success('Successfully Wiped Control Event', 'Endpoint Control Event', { timeOut: 3000 });
        },  
        error => {
          this.toastr.error('Failed to Wipe Control Event', 'Endpoint Control Event', { timeOut: 3000 });
        }
      );
  }

  /**
   * Handles the submitting of endpoint control data
   * @param input
   */
  submitEndpointControl(input: any): void {
    this.isEndpointControlSubmitting = true
  
    this.dashboardService
      .EucsDashboardControlEndpoint({expiration: input.expiration, endpointId: input.id, command: input.command})
      .subscribe(
        data => {
          this.alarmDashboardService.getDashboardMeterDetails();
          this.closeEndpointControl();
          this.isEndpointControlSubmitting = false;
          this.toastr.success('Successfully Set Control Event', 'Endpoint Control Event', { timeOut: 3000 });
        },  
        error => {
          this.isEndpointControlSubmitting = false;
          this.toastr.error('Failed to Submit Control Event', 'Endpoint Control Event', { timeOut: 3000 });
        }
      )

  }

}

